"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class LedgerService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchAllLedgerEntry(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.outlet_id !== null
                    ? this.baseUrl +
                        'business/ledger/entry/list?ledger_id=' +
                        payload.ledger_id +
                        '&outlet_id=' +
                        payload.outlet_id +
                        '&page=' +
                        payload.pageNumber +
                        '&limit=' +
                        payload.limit
                    : this.baseUrl +
                        'business/ledger/entry/list?ledger_id=' +
                        payload.ledger_id +
                        '&page=' +
                        payload.pageNumber +
                        '&limit=' +
                        payload.limit;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const respData = response.data;
                return respData;
            }
            catch (error) {
                throw new Error('Error while fetching ledger entry');
            }
        });
    }
    fetchLatestLedgerEntry(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.outlet_id !== null
                    ? this.baseUrl +
                        'business/ledger/entry?ledger_id=' +
                        payload.ledger_id +
                        '&outlet_id=' +
                        payload.outlet_id
                    : this.baseUrl +
                        'business/ledger/entry?ledger_id=' +
                        payload.ledger_id;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    }
                });
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error('Error while fetching ledger entry');
            }
        });
    }
    fetchTbpBillAmount(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = payload.outlet_id !== null
                    ? this.baseUrl +
                        'hotel_billing/bill/tbp_amt_by_customer?customer_id=' +
                        payload.customer_id +
                        '&outlet_id=' +
                        payload.outlet_id
                    : this.baseUrl +
                        'hotel_billing/bill/tbp_amt_by_customer?customer_id=' +
                        payload.customer_id;
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data;
            }
            catch (error) {
                throw new Error('Error while fetching tbp bill amount');
            }
        });
    }
    createLedger(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'business/ledger';
                payload = JSONbig.stringify(payload);
                let response = yield axios_1.default.post(url, payload, {
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error('Error while creating ledger');
            }
        });
    }
    creditRepay(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'business/ledger/credit/pay';
                payload = JSONbig.stringify(payload);
                let response = yield axios_1.default.post(url, payload, {
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error('Error while repaying credit');
            }
        });
    }
}
exports.LedgerService = LedgerService;
